import { Injectable, OnDestroy } from '@angular/core';
import { SocketEvent } from './socket-event';
import { Subject, Subscription } from 'rxjs';
import { WebSocketIoBase } from './web-socket-io-base';
import { ITokenAndUserId, SessionStorageService } from '../session-storage.service';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable()
export class WebSocketSessionService extends WebSocketIoBase implements OnDestroy {
    private readonly tokenAndUserIdSubscription: Subscription;
    readonly EVENTS = {
        LOGOUT: new SocketEvent('logout', new Subject<any>())
    };

    constructor() {
        super();
        this.tokenAndUserIdSubscription = SessionStorageService.TokenAndUserIdObservable
            .pipe(tap(value => this.handleTokenAndUserIdChanges(value)))
            .subscribe();

    }

    protected get events(): SocketEvent<any>[] {
        return Object.values(this.EVENTS);
    }

    ngOnDestroy(): void {
        this.unsubscribeSioEvents();
        if (this.tokenAndUserIdSubscription != null) {
            this.tokenAndUserIdSubscription.unsubscribe();
        }

    }

    private handleTokenAndUserIdChanges(tokenAndUserId: ITokenAndUserId) {
        // set token
        const token = tokenAndUserId.token;
        const userId = tokenAndUserId.userId;
        const tokenIsNull = token == null || token.length === 0;
        const userIdIsNull = userId == null || userId.length === 0;
        console.log(
            `The authentication token and/or the user id have changed.\n` +
            `New token is ${tokenIsNull ? 'null' : 'not null'}.\n` +
            `New userId is ${userIdIsNull ? 'null' : 'not null'}.`
        );

        // close and/or open connection
        this.closeSocketConnection();
        if (!tokenIsNull && !userIdIsNull) {
            this.openSocketConnection(token, userId);
        }
    }

    private openSocketConnection(token: string, id: string): void {
        const url: string = environment.websocket_session_url;
        const options: SocketIOClient.ConnectOpts = {
            query: {
                applicationName: environment.application_name,
                auth_code: token,
                userId: id
            },
            transports: ['websocket'],
            upgrade: false,
            path: '/session',
            reconnection: true,
            reconnectionAttempts: 20,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 30000
        };
        this.openSocketConnectionInternal(url, options);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/web-socket/web-socket-session.service.ts